import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon } from 'lucide-react';
const Header = () => {
  return <header className="bg-white" data-id="element-5691">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-5692"></div>
      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-5693">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-5694">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-5695">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-5696">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>
        <div className="flex justify-start mb-3" data-id="element-5697">
          <div className="text-xs text-gray-400 font-sans" data-id="element-5698">Advertorial 1</div>
        </div>
        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-5699">
          <div className="text-left" data-id="element-5700">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-5701">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-5702">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>
      {/* Article header */}
      <div className="px-4 sm:px-8 lg:px-12 py-6 sm:py-8 lg:py-10 border-b border-gray-200" data-id="element-5703">
        <div className="max-w-4xl mx-auto" data-id="element-5704">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4 sm:mb-5" data-id="element-5705">
            INVESTIGATIVE REPORT
          </div>
          <h1 className="font-serif text-2xl sm:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-5 sm:mb-7" data-id="element-5706">
            Nurse Practitioner Investigates: Do 'Earthing' Mats Actually Work —
            And How Safe Are They?
          </h1>
          <div className="mb-5 sm:mb-7" data-id="element-5707">
            <img src="https://cdn.magicpatterns.com/uploads/v7CSKhevW4vQiifJdd7vDy/gFqj1z2FYnYD-B6nNeVWC_taPz6fSF.png" alt="Illustration of a foot on an earthing mat connected to an electrical outlet" className="w-full rounded-md" data-id="element-5708" />
          </div>
          <div className="flex items-start mb-5 sm:mb-7 border-b border-gray-200 pb-5 sm:pb-7" data-id="element-5709">
            <div className="w-14 h-14 sm:w-16 sm:h-16 overflow-hidden rounded-full flex-shrink-0 mr-4 sm:mr-5 border border-gray-300" data-id="element-5710">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5V1KLd9diP6p4Lsag55oX2/YYkJmGMhE_ELwA2hWH_Ii.jpg" alt="Patricia Chen" className="w-full h-full object-cover" data-id="element-5711" />
            </div>
            <div className="flex-1" data-id="element-5712">
              <div className="flex items-center" data-id="element-5713">
                <div className="font-medium text-gray-900 text-lg sm:text-xl" data-id="element-5714">
                  By Patricia Chen, RN, MSN
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-5715">
                  <CheckCircleIcon className="h-4 w-4 sm:h-5 sm:w-5" data-id="element-5716" />
                  <span className="text-xs sm:text-sm ml-1 font-medium" data-id="element-5717">
                    Verified
                  </span>
                </div>
              </div>
              <div className="text-sm sm:text-base text-gray-600 mb-2" data-id="element-5718">
                Former Head of Integrative Medicine, Cedar Sinai Medical Center
              </div>
              <div className="flex text-xs sm:text-sm text-gray-500 items-center" data-id="element-5719">
                <div className="flex items-center mr-4" data-id="element-5720">
                  <ClockIcon className="h-3 w-3 sm:h-4 sm:w-4 mr-1" data-id="element-5721" />
                  <span data-id="element-5722">12 min read</span>
                </div>
                <div className="flex items-center" data-id="element-5723">
                  <EyeIcon className="h-3 w-3 sm:h-4 sm:w-4 mr-1" data-id="element-5724" />
                  <span data-id="element-5725">18,432 views</span>
                </div>
              </div>
            </div>
          </div>
          <p className="font-serif text-gray-700 text-base sm:text-lg lg:text-xl mb-6 sm:mb-8 leading-relaxed border-l-4 border-gray-300 pl-4 sm:pl-6 italic" data-id="element-5726">
            After 30 years in medicine, I've seen every "miracle cure" come and
            go. So when patients started asking about "grounding" mats — devices
            that supposedly connect your body to the earth's electrical field —
            I decided to investigate. What I found will surprise you.
          </p>
          <div className="border-t border-gray-200 pt-3 sm:pt-4 text-xs sm:text-sm text-gray-500 flex flex-wrap justify-between" data-id="element-5727">
            <div className="mb-1 flex items-center" data-id="element-5728">
              <span className="font-medium mr-2" data-id="element-5729">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-5730">
              <span className="font-medium mr-2" data-id="element-5731">Published:</span>
              February 2026
            </div>
          </div>
        </div>
      </div>
      {/* Author image */}
      <div className="px-4 sm:px-8 py-6 border-b border-gray-200" data-id="element-5732">
        <div className="max-w-4xl mx-auto" data-id="element-5733">
          <div className="sm:flex items-center" data-id="element-5734">
            <div className="sm:w-1/3 mb-4 sm:mb-0 sm:mr-6" data-id="element-5735">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" alt="Patricia Chen, RN, MSN in hospital corridor" className="w-full rounded-lg shadow-md" data-id="element-5736" />
            </div>
            <div className="sm:w-2/3" data-id="element-5737">
              <p className="text-sm text-gray-700 mb-2" data-id="element-5738">
                <span className="font-bold" data-id="element-5739">Patricia Chen, RN, MSN</span> has
                spent three decades in clinical practice specializing in
                integrative medicine approaches. As the former Head of
                Integrative Medicine at Cedar Sinai Medical Center, she has
                evaluated hundreds of wellness products and alternative
                treatments throughout her career.
              </p>
              <p className="text-sm text-gray-700" data-id="element-5740">
                Her investigative work focuses on separating evidence-based
                treatments from marketing hype, helping patients make informed
                health decisions based on scientific testing rather than trends.
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default Header;